// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"306a8c52","977":"3becd578"}[chunkId] + ".chunk.js";
};